import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { MobileDrawer } from './MobileDrawer';
import { SecretaryWidget } from '@modules/ai-secretary';

export function AppLayout() {
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden">
      {/* PC: 固定サイドバー */}
      <div className="hidden lg:flex lg:flex-shrink-0">
        <Sidebar />
      </div>

      {/* モバイル: ドロワー */}
      <MobileDrawer
        isOpen={isMobileOpen}
        onClose={() => setIsMobileOpen(false)}
      />

      {/* メインエリア */}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <TopBar onMenuToggle={() => setIsMobileOpen((prev) => !prev)} />
        <main className="flex-1 bg-gray-100 overflow-auto p-4 md:p-6">
          <Outlet />
        </main>
      </div>

      {/* AI秘書ウィジェット（付加サービス。課金OFF/未接続時は自身で非表示・睡眠を判定） */}
      <SecretaryWidget />
    </div>
  );
}
